export const IMAGE_LOADED = Symbol('IMAGE_LOADED')

const INITIAL_STATE = {
  imagesLoaded: new Set([]),
}

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state = INITIAL_STATE, action) => {
  if (action.type === IMAGE_LOADED) {
    if (typeof action.url !== 'string') {
      return state
    }

    return {
      ...state,
      imagesLoaded: state.imagesLoaded.add(action.url),
    }
  }

  return state
}

// Actions
export const addImageLoaded = url => ({ type: IMAGE_LOADED, url })

// Selectors
export const isImageLoaded = (state, url) => {
  if (!state.images || !state.images.imagesLoaded) {
    return false
  }

  return state.images.imagesLoaded.has(url)
}
